import React = require("react");
import {LoaderTab} from "../../components/Utils/loader/LoaderTab";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import MarketingCategory = MarketingConfig.MarketingCategory;
import {MarketingConfig} from "./data/MarketingConfig";
import "./MarketingReports.scss";
import {MarketingTab} from "./MarketingTab";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";
// tslint:disable-next-line:no-submodule-imports
import {EmptyState} from "@vebox/etui-core/EmptyState";
import {infoIcons} from "@vebox/etui-core";

interface ComponentProps {
    /** String because they must be immutable. */
    filters: string;
    /** Function to open the location tab. */
    goToLocation: () => any;
    isDetailLevel: boolean;
}

interface ComponentState {
    filters: string;
    categories: MarketingCategory[];
    currentCategory: MarketingCategory;
}

declare var AppTranslations: AppTranslations;

export class MarketingReports extends React.Component<ComponentProps, ComponentState> {
    private static logEnabled: boolean = false;

    constructor(props) {
        super(props);
        this.state = {filters: this.props.filters, categories: null, currentCategory: null};
        this.onReportChange = this.onReportChange.bind(this);
        this.initialize(this.props.filters);
    }

    public componentWillUpdate(nextProps: Readonly<ComponentProps>,
                               nextState: Readonly<ComponentState>,
                               nextContext: any) {
        this.log("Component will update");
        if (nextState.filters !== this.state.filters) {
            this.setState({categories: null});
            this.initialize(nextState.filters);
        }
    }

    public render() {
        let component;
        if (this.state.categories == null) {
            component = (
                <div className={"marketing-reports"}>
                    <LoaderTab/>;
                </div>
            );
        } else if (this.state.categories.length === 0) {
            component = (
                <div className={"marketing-reports--no-data"}>
                    <EmptyState>
                        <EmptyState.InfoIcon
                            styles={{
                                root: {
                                    color: "var(--empty-indicator-svg-stroke)",
                                }
                            }}
                            glyph={infoIcons.NoContent}
                        />
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                        <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                    </EmptyState>
                </div>
            );
        } else {
            const categoriesTabs = (
                <div className={"second-level-tabbar"}>
                    {this.state.categories.map(
                        (e: MarketingCategory, index) => {
                            let selectorClasses = "second-level-tabbar__button";
                            if (e.categoryGuid === this.state.currentCategory.categoryGuid) {
                                selectorClasses += " selected";
                            }
                            return (
                                <div
                                    className={selectorClasses}
                                    key={index}
                                    data-id={e.categoryGuid}
                                    onClick={this.onReportChange}
                                >
                                    <p
                                        title={AppTranslations.siteMarketing.equipmentHistoricallyAssignedToSite}
                                        className={"flx-row"}
                                    >
                                        {e.categoryName} ({e.totalEquipment})
                                        <span className={"material-icons-outlined"}>history</span>
                                    </p>
                                </div>
                            );
                        },
                    )}
                </div>
            );
            component = (
                <div className={"marketing-reports"}>
                    {categoriesTabs}
                    <MarketingTab
                        filters={this.state.filters}
                        goToLocation={this.props.goToLocation}
                        isDetailLevel={this.props.isDetailLevel}
                        componentCategory={this.state.currentCategory}
                    />
                </div>
            );
        }

        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                {component}
            </ThemeProvider>
        );
    }

    private onReportChange(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        const guid = e.currentTarget.dataset.id;
        const category: MarketingConfig.MarketingCategory = this.state.categories.filter(
            (cat) => cat.categoryGuid === guid,
        )[0];
        this.setState({currentCategory: category});
    }

    private initialize(filters) {
        this.log("Retrieving marketing components categories: ");
        Ajax.ajaxRequestForJson(
            {
                url: "marketing/categories/",
                data: filters,
                type: "POST",
                success: (data: MarketingConfig.MarketingCategory[]) => {
                    if (this.state.filters === filters) {
                        this.log("Success retrieving component categories data");
                        this.log(data);
                        this.setState({
                            categories: data,
                            currentCategory: data.length > 0 ? data[0] : null,
                        });
                    } else {
                        this.log("Retrieved categories but filters/date changed");
                    }
                },
            },
        );
    }

    // noinspection JSMethodCanBeStatic
    private log(message: any): void {
        if (MarketingReports.logEnabled) {
            console.log(message);
        }
    }
}
